module.exports = __webpack_public_path__ + "static/media/right-arrow-2.6afdfe6b.svg";